import React, { useEffect, useState } from "react";
import "./BackgroundSlideshow.css";

const images = [
  require("../assets/Tire-Recycling-Plants.jpg"),
  require("../assets/recyclying-tires.jpg"),
  require("../assets/Tire-Recycling-Green.webp"),
  require("../assets/tire_pile.webp"),
];
const truckVideo = require("../assets/green-truck-on-highway.mp4");

const BackgroundSlideshow: React.FC = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (showVideo) {
      interval = setTimeout(() => {
        setShowVideo(false);
        setCurrentImageIndex(0); // Restart slideshow after video
      }, 8000); // Show video for 10 seconds
    } else {
      interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => {
          if (prevIndex + 1 === images.length) {
            setShowVideo(true); // Show video after last image
            return prevIndex;
          }
          return (prevIndex + 1) % images.length;
        });
      }, 3000); // Change image every 3 seconds
    }

    return () => clearInterval(interval);
  }, [showVideo]);

  return (
    <div className="background-container">
      {showVideo ? (
        <video autoPlay muted playsInline className="background-video">
          <source src={truckVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <div className="slideshow">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              className={`slideshow-image ${index === currentImageIndex ? "active" : ""}`}
              alt={`Slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BackgroundSlideshow;
